import { render, staticRenderFns } from "./AdminWorkplaceIngredients.vue?vue&type=template&id=75e1c9cd&"
import script from "./AdminWorkplaceIngredients.vue?vue&type=script&lang=js&"
export * from "./AdminWorkplaceIngredients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports